"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NodeContainer = function NodeContainer(props) {
  var item = props.item,
      classes = props.classes,
      render = props.render,
      _onClick = props.onClick,
      direction = props.direction,
      children = props.children,
      round = props.round;
  return _react.default.createElement(_styles.Node, {
    id: item.id,
    styles: classes.lines
  }, round && _react.default.createElement(_styles.Round, {
    color: classes.lines.color
  }), direction && item.parent && _react.default.createElement(_styles.Arrow, {
    color: classes.lines.color
  }), typeof render === 'function' ? _react.default.cloneElement(render(item), {
    onClick: function onClick() {
      return _onClick(item);
    },
    styles: classes.node
  }) : _react.default.createElement(_styles.Wrapper, {
    styles: classes.node,
    onClick: function onClick() {
      return _onClick(item);
    }
  }, _react.default.createElement(_styles.Text, {
    styles: classes.text
  }, item.name)), children);
};

NodeContainer.propTypes = {
  item: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  classes: _propTypes.default.objectOf(_propTypes.default.object),
  render: _propTypes.default.func,
  onClick: _propTypes.default.func,
  direction: _propTypes.default.bool,
  children: _propTypes.default.node,
  round: _propTypes.default.bool
};
NodeContainer.defaultProps = {
  classes: {
    lines: {
      height: '60px',
      width: '2px'
    },
    node: {},
    text: {},
    arrow: {}
  },
  render: null,
  onClick: null,
  direction: false,
  children: null,
  round: false
};
var _default = NodeContainer;
exports.default = _default;